var JobSeekerData = [
  {
    id: 1,
    process: "Register",
    imgUrl: "user.png",
  },
  {
    id: 2,
    process: "View Jobs",
    imgUrl: "search.png",
  },
  {
    id: 3,
    process: "Apply",
    imgUrl: "check.png",
  },
  {
    id: 4,
    process: "Get Hired",
    imgUrl: "thumb.png",
  },
];

export default JobSeekerData;
